import { render, staticRenderFns } from "./CustomerDirectorsProxies.vue?vue&type=template&id=776b50d2"
import script from "./CustomerDirectorsProxies.vue?vue&type=script&lang=js"
export * from "./CustomerDirectorsProxies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports